goog.provide('el8.appchart.dialog.addEditAllergy');

goog.require('el8.ptdata.ptAllergies');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.appchart.dialog.addEditAllergy');
goog.require('el8.service.infoField');
goog.require('el8.util.consts');
goog.require('el8.data.allergies');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.appshared.form.buttons');

el8.appchart.dialog.addEditAllergy = (function() {

    var currPtAllergy = null;
    var selectedAllergy = null;
    var selectedReaction = null;
    var saveCb = null;
    var stickySaveCb = false;

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Patient Allergy',
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appchart.dialog.addEditAllergy.form({
                statusChoices: el8.util.consts.ALLERGY_STATUS_CHOICES,
                severitySnomeds: el8.util.consts.ALLERGY_SEVERITY_SNOMEDS
            });
        }
    });

    var allergyMindreaderOpts = el8.appshared.mindreaderOpts.allergies();
    allergyMindreaderOpts['selectFn'] = function(event, item) {
        selectedAllergy = el8.data.allergies.create(item);
    };
    var reactionMindreaderOpts = el8.appshared.mindreaderOpts.snomedCodes();
    reactionMindreaderOpts['selectFn'] = function(event, item) {
        selectedReaction = el8.data.snomedCodes.create(item);
    }
    reactionMindreaderOpts['formatSelected'] = function(item) {
        return item.description;
    }

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'manualAllergyName',
                selector: ':input[name="manualAllergyName"]',
                infoText: 'name of allergy...',
                maxLength: 255,
                height: el8.util.consts.XL_FIELD_HEIGHT,
                mindreaderOpts: allergyMindreaderOpts
            },
            {
                name: 'reaction',
                selector: ':input[name="reaction"]',
                infoText: 'reaction...',
                maxLength: 255,
                height: el8.util.consts.XL_FIELD_HEIGHT
            },
            {
              name: 'manualReactionSnomedDescription',
              selector: ':input[name="manualReactionSnomedDescription"]',
              height: el8.util.consts.XL_FIELD_HEIGHT,
              infoText: 'reaction snomed...',
              mindreaderOpts: reactionMindreaderOpts
            },
            {
              name: 'severity',
              selector: ':input[name="severity"]'
            },
            {
                name: 'startDate',
                selector: ':input[name="startDate"]',
                infoText: 'e.g. YYYY',
                datePickerOpts: {}
            },
            {
                name: 'status',
                selector: ':input[name="status"]'
            }
        ]
    });

    var doSave = function(_form, addAnother) {

        if (!currPtAllergy) {
            currPtAllergy = el8.ptdata.ptAllergies.create(form.getMapped(), true);
        } else {
            currPtAllergy.populate(form.getMapped());
        }
        
        if (!currPtAllergy.getManualAllergyName()) {
            el8.uiwidget.alert('Please enter an allergy name.', form.getInfoField('manualAllergyName').getInputField());
            return;
        }

        // Set allergy ID if selectedAllergy's name still matches what is manually input
        if (selectedAllergy && (selectedAllergy.getName() === currPtAllergy.getManualAllergyName())) {
            currPtAllergy.setAllergyId(selectedAllergy.getId());
        } else {
            currPtAllergy.setAllergyId(null);
        }

        // Set reaction ID if selectedReaction's name still matches what is manually input
        if (selectedReaction && (selectedReaction.getDescription() === currPtAllergy.getManualReactionSnomedDescription())) {
            currPtAllergy.setReactionSnomedId(selectedReaction.getId());
        } else {
            currPtAllergy.setReactionSnomedId(null);
        }
        
        if (currPtAllergy.getStartDate()) {
            if (el8.util.datecompare.isAfterToday(currPtAllergy.getStartDate())) {
                el8.uiwidget.alert('Please enter a start date in the past', form.getInfoField('startDate').getInputField());
                return;
            } else if (currPtAllergy.getStartDate() < el8.ptdata.currPatient.getDob()) {
                el8.uiwidget.alert('Start date cannot be before patient\'s date of birth', form.getInfoField('startDate').getInputField());
                return;
            }
        }
        
        el8.ptdata.ptAllergies.saveItem(currPtAllergy, false, {
            successCb: function() {
                // Hold onto references for these because the hide() call later
                // in this function will reset them to null and we'd lose
                // access to them otherwise. Need them to forward to next
                // `show()` call if `stickySaveCb` is true.
                var _saveCb = saveCb;
                var _stickySaveCb = stickySaveCb;

                if (_saveCb) { _saveCb(currPtAllergy); }
                that.hide();
                if (addAnother === true) { 
                    if (_stickySaveCb) {
                        that.show({
                            saveCb: _saveCb,
                            stickySaveCb: true
                        });
                    } else {
                        that.show(); 
                    }
                }
            }
        });
    };

    el8.appshared.form.buttons.addNonDraftDialogButtons(form, doSave, that);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        spec = spec || {};
        currPtAllergy = spec.ptAllergy || null;
        saveCb = spec.saveCb || null;
        stickySaveCb = spec.stickySaveCb || false;
        if (currPtAllergy) {
            that.setTitle('Edit Patient Allergy');
            form.showDiscardChangesCaption();
            form.populate({
                'manualAllergyName': currPtAllergy.getAllergyName(),
                'manualReactionSnomedDescription': currPtAllergy.getReactionSnomedDescription(),
                'reaction': currPtAllergy.getReaction(),
                'severity': currPtAllergy.getSeverity(),
                'startDate': currPtAllergy.getStartDate() ? currPtAllergy.getStartDate().asString() : '',
                'status': currPtAllergy.getStatus()
            });
        } else {
            that.setTitle('Add Patient Allergy');
            form.showDiscardCaption();
            if (spec.description) {
                form.populate({'manualAllergyName': spec.description});
            }
        }
        form.initFocus();
    };

    var super_hide = that.hide;
    that.hide = function() {
        currPtAllergy = null;
        saveCb = null;
        stickySaveCb = false;
        super_hide.call(that);
    };

    return that;

})();

